import React from 'react'
import HelpIcon from '@mui/icons-material/Help';

function Tooltip({ text }) {
    return (
        <div className="tooltip">
            <HelpIcon className='icon' />
            <span className="text">{text}</span>
        </div>
    )
}

export default Tooltip